'use strict';

var IPFSRepo = require('ipfs-repo');

module.exports = function (options) {
  options = options || {};
  var repoPath = options.path || 'ipfs';
  return new IPFSRepo(repoPath, {
    autoMigrate: options.autoMigrate
  });
};